import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ValidationErrorService } from './validation-error.service';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TrimFormControl } from '../form/trim-control';
import { TouchFormControl } from './touch-form-control.modal';
import { ValidationEnum } from './validation-enum.model';

@Component({
  selector: 'app-validation-banner',
  templateUrl: './validation-banner.component.html',
  styleUrls: ['./validation-banner.component.scss']
})
export class ValidationBannerComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() show: boolean;

  private subscriptions: Subscription[] = new Array<Subscription>();
  public validatationEnum: ValidationEnum;

  constructor(private validationService: ValidationErrorService) {}

  ngOnInit() {
    this.validationService.loadForm(this.form);
    this.subscriptions.push(
      this.form.statusChanges.subscribe(event => {
        this.validationService.generateErrors();
      })
    );
    Object.keys(this.form.controls).forEach(control => {
      if (this.form.get(control) instanceof TrimFormControl) {
        this.subscriptions.push(
          (this.form.get(control) as TrimFormControl).touchedChanges.subscribe(
            event => {
              this.validationService.generateErrors();
            }
          )
        );
      } else if (this.form.get(control) instanceof TouchFormControl) {
        this.subscriptions.push(
          (this.form.get(control) as TouchFormControl).touchedChanges.subscribe(
            event => {
              this.validationService.generateErrors();
            }
          )
        );
      } else {
        this.subscriptions.push(
          this.form.get(control).statusChanges.subscribe(event => {
            this.validationService.generateErrors();
          })
        );
      }
    });
  }

  public validError(error: any): boolean {
    return ValidationEnum[error] !== '';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      if (!sub.closed) {
        sub.unsubscribe();
      }
    });
  }

  public get showValidationBanner(): boolean {
    return this.validationService.showBanner;
  }

  public get errorList(): string[] {
    return this.validationService.errorList;
  }
}
